// @ts-nocheck
import { Room, Client, getStateCallbacks, RoomAvailable} from "colyseus.js";
import { State } from "../server/schemas/State";
import { fetchProjData, Point, projData } from "./Utility";
// import { createInterpolator } from 'svg-path-interpolator';

// import * as bootstrap from 'bootstrap'
import Two from "two.js";
import { getRenderer, fetchGraphics, ChoiceModal, Viewport, offsetTime, UsernameModal } from "./Renderer";
import { Application } from "./Application";
// export const ENDPOINT = "https://ca-yto-b4dea50b.colyseus.cloud";
export const ENDPOINT = "http://localhost:2567";
const WORLD_SIZEX = 1000;
const WORLD_SIZEY = 500;

const NAMES = ['Primary', 'Secondary', 'Tertiary']

export class Lobby{
    client: Client
    lobby: Room
    choiceModal: ChoiceModal
    rooms: {[key: string]: RoomAvailable} = {}
    roomCards: {[key: string]: any} = {}

    app: Application
    weapons = [null, null, null]

    constructor(app){
        this.client = app.client
        this.choiceModal = new ChoiceModal(document.getElementById('choiceModal'), app)
        this.app = app
        this.prepareUI()
        this.connect()
    }

    showModal(i){
        console.log('SHOW', i)
        this.choiceModal.buttonCallback = (idx) => {
            this.setChoice(i, Object.entries(projData)[idx][0])
        }
        this.choiceModal.show()
    }

    setChoice(i, proj){
        var elem = document.querySelector(`#weapon${i}`)
        elem.querySelector('.card-title').innerText = projData[proj].title
        elem.querySelector('.card-text').innerText = projData[proj].desc
        this.weapons[i] = proj
    }

    getUsername(){
        return document.querySelector('#usernameInput').value
    }

    prepareUI(){
        this.choiceModal.setChoices(Object.entries(projData).map(([k, v]) => v))
        for (let i = 0; i < 3; i++){
            var elem = document.createElement('div');
            (['row', 'align-items-center', 'mb-3']).forEach((e) => elem.classList.add(e));
            elem.innerHTML = `
                <div class="col-3 d-flex align-items-center justify-items-center text-center">
                    <span class="fw-bold">${NAMES[i]} Weapon</span>
                </div>
                <div class="col-9">
                    <div class="card clickable-card" id="weapon${i}">
                        <div class="card-body">
                        <h5 class="card-title mb-1"></h5>
                        <p class="card-text mb-0"></p>
                        </div>
                    </div>
                </div>`
            elem.addEventListener('click', () => {
                this.showModal(i)
            })
            document.querySelector('#loadout').append(elem)
            document.querySelector('#roomCreator').addEventListener('pointerdown', (e) => {
                app.setRoom()
            })
            this.setChoice(i, 'basic')
        }
    }

    updateRoomCard(room){
        let elem = this.roomCards[room.roomId] ?? this.createRoomCard(room)
        elem.querySelector('span').innerText = `Clients: ${room.clients}`
        elem.querySelector('.card-title').innerText = `${room.roomId}`
    }

    createRoomCard(room){
        let elem = document.createElement('div');
        (['card', 'clickable-card']).forEach((e) => elem.classList.add(e))
        elem.innerHTML = `<div class="card-body">
            <h5 class="card-title"></h5>
            <span></span>
        </div>`
        document.querySelector('#roomList').append(elem)
        elem.addEventListener('click', () => {
            app.setRoom(room.roomId)
        })
        console.log(elem)
        this.roomCards[room.roomId] = elem
        return elem
    }

    removeRoomCard(room){
        if(this.roomCards[room.roomId]){
            this.roomCards[room.roomId].remove()
            delete this.roomCards[room.roomId]
        }
    }

    async connect(){
        this.lobby = await this.client.joinOrCreate("lobby");
        this.lobby.onMessage("rooms", (rooms) => {
            rooms.forEach((e) => {
                this.rooms[e.roomId] = e 
                this.updateRoomCard(e)
            })
        });
        this.lobby.onMessage("+", ([roomId, room]) => {
            this.rooms[roomId] = room
            this.updateRoomCard(room)
        });
        this.lobby.onMessage("-", ([roomId, room]) => {
            delete this.rooms[roomId]
            this.removeRoomCard(room)
        });
    }
}
